import * as React from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import REVIEW_AVATAR from './review-avatar.png'

import {
  Container,
  StarContainer,
  Star,
  ReviewAvatar,
  TextContainer,
  Title,
  Subtitle,
  CloseButton,
  ReadButton,
  Content,
  Buttons,
} from './styles'

interface Props {
  viewResumeCritiqueReview: () => void
  reviewerName: string
}

export const CritiqueFinishedBanner = ({ viewResumeCritiqueReview, reviewerName }: Props) => {
  const [hide, setHide] = React.useState(false)
  const { i18n } = useI18n()

  React.useEffect(() => {
    trackInternalEvent('see_resume_critique_banner', { where: 'builder' })
  }, [])

  return (
    <Container $hide={hide} data-testid="critique-finished-banner">
      <Content>
        <ReviewAvatar src={REVIEW_AVATAR} />
        <StarContainer>
          <Star />
        </StarContainer>
        <TextContainer>
          <Title>{i18n.t('builder.critique_entry_points.critique_finished_banner.title')}</Title>
          <Subtitle>
            {i18n.t('builder.critique_entry_points.critique_finished_banner.subtitle', {
              reviewer_name: reviewerName,
            })}
          </Subtitle>
        </TextContainer>
      </Content>
      <Buttons>
        <CloseButton onClick={() => setHide(true)}>
          {i18n.t('builder.critique_entry_points.critique_finished_banner.close')}
        </CloseButton>
        <ReadButton onClick={viewResumeCritiqueReview}>
          {i18n.t('builder.critique_entry_points.critique_finished_banner.read')}
        </ReadButton>
      </Buttons>
    </Container>
  )
}
